import React, { FC } from 'react';
import i18n from 'i18n';
import styled from 'styled-components';

import { ModalProps } from '../types';
import { RowsContainer } from '../Common';
import Modal from '../../Modal/index';
import { ModalImageContainer } from '../../ImageContainer/ModalImageContainer';
import { ModalGrayText } from '../../Common';

const UninstallContentContainer = styled(RowsContainer)`
  display: flex;
  flex-direction: column;
  text-align: center;
  margin-top: 0px;
  margin-bottom: 25px;
  align-items: center;
`;

const AppBannerDiv = styled.div`
  margin-bottom: 15px;
`;

type UninstallTileModalProps = ModalProps

export const UninstallTileModal: FC<UninstallTileModalProps> = ({ app, deviceName, onCancel, onSuccess, loading }) => (
  <Modal
    id={`UninstallTileModal`}
    title={i18n('component.UninstallTileModal.title')({ tileName: app.name })}
    onClose={onCancel}
    contentCenter={
      <UninstallContentContainer>
        <AppBannerDiv>
          <ModalImageContainer app={app} deviceName={deviceName} />
        </AppBannerDiv>
        <ModalGrayText>
          {i18n('component.UninstallTileModal.content')({ tileName: app.name})}
        </ModalGrayText>
      </UninstallContentContainer>
    }
    buttons={[
      {
        text: i18n('component.UninstallModal.CancelText')(),
        onClick: onCancel,
        testType: 'cancel-button',
        id: 'uninstall-button-cancel'
      },
      {
        text: loading ? i18n('component.UninstallTileModal.loading')() : i18n('component.UninstallTileModal.UninstallText')(),
        loading: loading,
        onClick: onSuccess,
        highlight: !loading,
        testType: 'uninstall-button',
        id: 'uninstall-button-ok'
      }
    ]}
  />
);
